//Duration (milliseconds), does not disappear when set to 0
export enum NotificationDuration {
  SUCCESS_NOTIFICATION_DURATION = 5000,
  INFO_NOTIFICATION_DURATION = 300000,
  WARNING_NOTIFICATION_DURATION = 5000,
  ERROR_NOTIFICATION_DURATION = 300000,
  INFINITE_DURATION = 0
}
